import React, {useLayoutEffect} from "react";
import {actions} from "../../store";
import {useDispatch, useSelector} from "react-redux";
import Loader from "../../components/Loader/Loader";
import {ReduxState} from "../../store/types";
import {makeStyles} from "@material-ui/styles";

const useStyles = makeStyles(()=>({
    loader: {
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
}))

const BillingDetailsWrapper:React.FC<any> = ({children}) => {

    const classes = useStyles()

    const dispatch = useDispatch();

    const {isLoading } = useSelector(
        (state: ReduxState) => state.billing,
    );

    useLayoutEffect(() => {
        dispatch(actions.getBasicBillingInfo.request());

        return ()=>{
            dispatch(actions.setBillingInitState());
        }

    }, []);

    if (isLoading) {
        return (
            <div className={classes.loader}>
                <Loader dataQa="extension-list-loader"/>
            </div>
        );
    }


    return children
}

export default BillingDetailsWrapper